export default __webpack_public_path__ + "static/media/user-profile-icon.02f3d412.svg";